import { useRouter } from 'next/router'
import { useQuery } from 'react-query'

// Libs
import { fetchCategoryMenu } from '@/api/fetchCategoryMenu'

// Constants
import { DEFAULT_LOCALE } from '@/constants/defaultLocale'
import { QUERY_KEY } from '@/constants/queryKey'

// 完整分類樹快取 1 小時，同一個 session 內瀏覽多筆商品只請求一次
const CATEGORY_MENU_CACHE_TIME = 60 * 60 * 1000

interface IParams {
  enabled?: boolean
}

export const useCategoryMenu = ({ enabled = true }: IParams = {}) => {
  const router = useRouter()
  const currentLocale = router.locale === 'default' ? DEFAULT_LOCALE : router.locale

  // locale 放進 query key 讓各語系有獨立快取，切換語系時才會以新語系重新請求、分類名稱跟著切換
  return useQuery([QUERY_KEY.FETCH_CATEGORY_MENU, { locale: currentLocale }], () => fetchCategoryMenu({ ssrLocale: currentLocale, params: {} }), {
    enabled,
    staleTime: CATEGORY_MENU_CACHE_TIME,
    cacheTime: CATEGORY_MENU_CACHE_TIME,
  })
}
